<script setup>
  import { ref } from "vue";
  import { Loader2 } from "lucide-vue-next";
  import { Button } from "@/components/ui/button";
  import { Tooltip } from "@/components/ui/tooltip";

  const props = defineProps({
    canTrigger: { type: Boolean, required: true },
    hasMissingFields: { type: Boolean, default: false },
    actionFunction: { type: Function, required: true },
  });

  const isLoading = ref(false);

  const handleAction = async () => {
    isLoading.value = true;
    await props.actionFunction();
    isLoading.value = false;
  };
</script>

<template>
  <Tooltip
    v-if="hasMissingFields"
    content="Please fill in all required fields"
    side="left">
    <span>
      <Button
        variant="destructive"
        class="opacity-50 cursor-not-allowed">
        Save
      </Button>
    </span>
  </Tooltip>
  <Button
    v-else
    :disabled="!canTrigger || isLoading"
    @click="handleAction">
    <Loader2
      v-if="isLoading"
      class="h-4 w-4 mr-2 animate-spin" />
    Save
  </Button>
</template>
